export default {
    submit: 'Submit'
}
